import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useStores } from 'util/mobx/stores';
import Picture from 'components/Picture';
import { PackageDTO, PackagingType } from 'dto/package';
import Button from 'components/Form/Button';
import { SelectableType } from 'stores/searchStore';

interface Props {
  packageItem: PackageDTO;
  isOnlySearch?: boolean;
  isLast?: boolean;
}

const SearchPackageItem = observer(({ packageItem, isLast }: Props) => {
  const { t } = useTranslation('materialSearch');
  const { guideDetailDrawerStore, searchStore } = useStores();

  const handleSelect = () => {
    if (searchStore.onSelect) {
      searchStore.onSelect({ pack: packageItem });
    }
  };

  const handleShowMaterialDrawerClick = () => {
    guideDetailDrawerStore.setSelectedPackage(packageItem);
    guideDetailDrawerStore.setIsOpen(true);
  };

  const showButton = searchStore.onSelect && searchStore.selectableTypes.indexOf(SelectableType.Package) >= 0;

  return (
    <div className={`div-block-27 search-material-item ${isLast ? 'last' : ''}`}>
      <div className="list_item_material_in_search search-material-list-item">
        <div className="image_wrapper_50" onClick={handleShowMaterialDrawerClick}>
          <div style={{ opacity: 0 }} className="image_border" />
          <Picture src={packageItem.picture?.pictureThumbnail} width="50" alt="" className="image_circle_50" />
        </div>
        <div className="material_info in_search material-info">
          <div className="div-block-34" onClick={handleShowMaterialDrawerClick}>
            <div className="material_text search-panel">
              <div>{packageItem.name}</div>
            </div>
          </div>
          <div className="div-block-30 search-panel">
            <div className="info_box material_search" onClick={handleShowMaterialDrawerClick}>
              {packageItem.packagingType === PackagingType.Multi ? <div>{t('searchItem.multi')}</div> : <div>{t('searchItem.single')}</div>}
            </div>
            {showButton && (
              <div onClick={handleSelect}>
                <Button className="btn_small_flyout">
                  <div className="txt_dropout_1">{searchStore.actionButtonLabel}</div>
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default SearchPackageItem;
